export const enum BUDGET_FREQUENCY {
  single = 'single',
  monthly = 'monthly',
  quarterly = 'quarterly',
  biannually = 'biannually',
  yearly = 'yearly',
}

export const enum BUDGET_FROM_TYPE {
  at_date = 'at_date',
  start_date = 'start_date',
  acquisition_date = 'acquisition_date',
}

export const enum BUDGET_TO_TYPE {
  retirement = 'retirement',
  undetermined = 'undetermined',
  duration_month = 'duration_month',
  duration_year = 'duration_year',
  end_date = 'end_date',
  disposal_date = 'disposal_date',
}

export const BUDGET_ITEM_FROM_TYPE_ASSOCIATION = {
  [BUDGET_FROM_TYPE.at_date]: 'fromDate',
  [BUDGET_FROM_TYPE.start_date]: 'fromDate',
  [BUDGET_FROM_TYPE.acquisition_date]: 'fromDate',
} as const

export type BudgetItemFromTypeAssociation = keyof typeof BUDGET_FROM_TYPE

export const BUDGET_ITEM_TO_TYPE_ASSOCIATION = {
  [BUDGET_TO_TYPE.retirement]: 'null',
  [BUDGET_TO_TYPE.undetermined]: 'null',
  [BUDGET_TO_TYPE.duration_month]: 'toValue',
  [BUDGET_TO_TYPE.duration_year]: 'toValue',
  [BUDGET_TO_TYPE.end_date]: 'toDate',
  [BUDGET_TO_TYPE.disposal_date]: 'toDate',
} as const

export type BudgetItemToTypeAssociation = keyof typeof BUDGET_TO_TYPE

export const EXPENSE_CATEGORY = 'Dépenses courantes'

export const BUDGET_ITEMS_ENTRY_TYPES = {
  asset: 'asset',
  liability: 'liability',
}

export const BUDGET_UX_CONTEXTS = {
  inTable: 'inTable',
}

export const BUDGET_MONTHLY_COEFFICIENT = {
  [BUDGET_FREQUENCY.single]: 0,
  [BUDGET_FREQUENCY.monthly]: 1,
  [BUDGET_FREQUENCY.quarterly]: 1 / 3,
  [BUDGET_FREQUENCY.biannually]: 1 / 6,
  [BUDGET_FREQUENCY.yearly]: 1 / 12,
} as const
